
import Vue from 'vue'
import Links from './Links.vue'
import Logo from './Logo.vue'
import Timer from './Timer.vue'
import ShareButton from './ShareButton.vue'
import SearchInput from './Search/SearchInput.vue'

import { mapState } from 'vuex'

export default Vue.extend({
  data() {
    const { is_enabled_search, is_enabled_share } = this.$store.state.project
    return {
      is_enabled_search,
      is_enabled_share,
    }
  },
  props: ['showSearch'],
  computed: {
    ...mapState(['timer']),
  },
  components: {
    Logo,
    Links,
    Timer,
    SearchInput,
    ShareButton,
  },
})
